import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Check, ChefHat } from 'lucide-react';

export default function MealPlanSelector({ plans, currentPlanId, onSelectPlan }) {
  if (!plans || plans.length <= 1) {
    return null; // Don't show selector if only one plan
  }

  const getPlanIcon = (planType) => {
    return <ChefHat className="h-4 w-4" />;
  };

  const getPlanBadgeColor = (planType) => {
    const colors = {
      regular: 'bg-blue-100 text-blue-700',
      simplified: 'bg-green-100 text-green-700',
      high_satiety: 'bg-purple-100 text-purple-700',
      high_protein: 'bg-orange-100 text-orange-700'
    };
    return colors[planType] || 'bg-gray-100 text-gray-700';
  };

  return (
    <Card className="mb-6 border-[#1a61e8]/20">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <ChefHat className="h-5 w-5 text-[#1a61e8]" />
          <h3 className="font-semibold text-gray-900">Your Meal Plans</h3>
          <Badge variant="outline">{plans.length} available</Badge>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {plans.map((plan, index) => {
            const isSelected = plan.id === currentPlanId || plan.currently_selected;
            // Auto-number plans if no plan_name exists
            const displayName = plan.plan_name || `Meal Plan ${index + 1}`;
            
            return (
              <div
                key={plan.id}
                className={`
                  relative p-4 rounded-lg border-2 transition
                  ${isSelected 
                    ? 'border-[#1a61e8] bg-[#1a61e8]/5' 
                    : 'border-gray-200 bg-white'
                  }
                `}
              >
                {isSelected && (
                  <div className="absolute top-2 right-2">
                    <div className="bg-[#1a61e8] rounded-full p-1">
                      <Check className="h-3 w-3 text-white" />
                    </div>
                  </div>
                )}
                
                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    {getPlanIcon(plan.plan_type)}
                    <span className="font-semibold text-gray-900">
                      {displayName}
                    </span>
                  </div>
                  
                  <Badge className={getPlanBadgeColor(plan.plan_type)}>
                    {plan.plan_type ? plan.plan_type.replace('_', ' ') : 'regular'}
                  </Badge>
                  
                  <div className="text-sm text-gray-600 space-y-1">
                    <div>{Math.round(plan.target_calories)} kcal/day</div>
                    <div>{plan.recipe_count || 0} recipes</div>
                  </div>
                  
                  <Button
                    onClick={() => onSelectPlan(plan.id)}
                    variant={isSelected ? "default" : "outline"}
                    className={`w-full mt-2 ${isSelected ? 'bg-[#1a61e8] hover:bg-[#1a61e8]/90' : ''}`}
                  >
                    {isSelected ? 'Current Plan' : 'View Plan'}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
        
        <p className="text-xs text-gray-500 mt-3">
          💡 All plans sync with your calorie adjustments
        </p>
      </CardContent>
    </Card>
  );
}
